import React, { useState, useContext } from "react";
import CustomButton from "../../components/CustomButton/CustomButton";
import { Fade, Modal } from "react-bootstrap";
import Label from "../Label/Label";
import BgImg from "../../assests/img/cancel.png";
import Close from "../../assests/img/close.png";
import "./ThankYouPopUp.scss";

const ThankYouPopUp = (props) => {
  return (
    <Modal
      className={"ThankYouPopUp " + props.className}
      show={props.showModal}
      animation={Fade}
      onHide={() => props.onHide()}
      centered
    >
      <Modal.Header>
        <div className="header-img">
          <img src={BgImg} className="bgImg"></img>
          <img src={Close} className="close"></img>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Label className="headerTitle" title="Thank You!"></Label>
        <Label className="name" title={props.userName || ""}></Label>
        <Label
          className="inner"
          title={
            props.meetingLink
              ? "Your meeting is confirmed. Use the link below to join the video call."
              : "Our executive will connect with you shortly."
          }
        ></Label>
        {props.meetingLink && (
          <a
            className="meeting-link"
            href={props.meetingLink}
            target="_blank"
            rel="noreferrer"
          >
            {props.meetingLink}
          </a>
        )}
      </Modal.Body>
      <div className="modal-footer">
        <CustomButton
          type="button"
          title="CONTINUE"
          onClick={() => props.onContinue?.()}
        />
      </div>
    </Modal>
  );
};
ThankYouPopUp.defaultProps = {
  className: "ThankYouPopUp",
  btnHide: true,
};

export default ThankYouPopUp;
